"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesFilterContainerv2 = void 0;
var attributes_filter_container_1 = require("./attributes-filter.container");
Object.defineProperty(exports, "AttributesFilterContainerv2", { enumerable: true, get: function () { return attributes_filter_container_1.AttributesFilterContainer; } });
